export default __webpack_public_path__ + "static/favicon-6f32ae46619c3e7ab89a6aea64419911.ico";